/**
 * 项目首页
 */
import React, { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import { Tabs } from 'antd-mobile-v5';
import styles from './collaborativeNew.module.scss';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import Utils from '../../utils/utils';
import banner from '../../static/images/sy.png';
import sign_up_head from '../../static/images_doctor/sign_up_head.png';
import sign_up_middle_up from '../../static/images_doctor/sign_up_middle_up.png';
import sign_up_middle_down from '../../static/images_doctor/sign_up_middle_down_new.png';
import sign_up_head2 from '../../static/images_doctor/sign_up_head2.png';
import sign_up_middle_up2 from '../../static/images_doctor/sign_up_middle_up2.png';
import sign_up_middle_down2 from '../../static/images_doctor/sign_up_middle_down2.png';
import sign_up_head3 from '../../static/images_doctor/sign_up_head3.png';
import sign_up_middle_up3 from '../../static/images_doctor/sign_up_middle_up3.png';
import sign_up_middle_down3 from '../../static/images_doctor/sign_up_middle_down3.png';
import sign_up_bottom from '../../static/images_doctor/sign_up_bottom.png';
import fzcz_detail from '../../static/images_doctor/fzcz_detail.png';
import iconFile from '../../static/images/icon_file.png';
import { RightOutline } from 'antd-mobile-icons'
import config from './config.json';
import utils from '../../utils/utils';

const api = new ApiCore();

let env = process.env.REACT_APP_ENV;

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

function Collaborative(props: any) {

    // 获取协作组code
    let collaborativeCode = Utils.getUrlParams().collaborativeCode

    // 公开文件
    const [openFileData, setOpenFileData] = useState<any>([]);
    // 下载文件
    const [downFileData, setDownFileData] = useState<any>([]);
    const [data, setData] = useState<any>({});

    // 获取活动activityCode
    let activityCode = utils.getUrlParams().activityCode;

    // 活动介绍
    const [introduction, setIntroduction] = useState<any>('');
    // 征集要求
    const [request, setRequest] = useState<any>('');
    // 项目code
    const [projectCodes, setprojectCodes] = useState<any>('');
    // 租户code
    const [tenantCode, setTenantCode] = useState<any>('');
    // 活动code
    const [activiCode, setActiviCode] = useState<any>('');


    let user_tenantCode = localStorage.getItem('tenantCode')


    useEffect(() => {
        //设置网页title
        document.title = '项目首页';
        getCollaborativeInfo();
        getData();
    }, [])

    // 获取活动数据
    const getData = () => {
        let params = {
            activityCode: activityCode ?? 'YMTSPZJ'
        }
        api.getProjectActivity(params).then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                let data = res.data;
                setIntroduction(data.introduction)
                setRequest(data.request)

                setprojectCodes(data.projectCode)
                setTenantCode(data.tenantCode)
                setActiviCode(data.code)

                let YMTCodes = {
                    projectCodes: data.projectCode,
                    tenantCode: data.tenantCode,
                    activityCode: data.code,
                }
                sessionStorage.setItem('YMTCodes', JSON.stringify(YMTCodes))
            }
        });
    }

    // 获取当前协作组信息
    const getCollaborativeInfo = () => {
        api.getCollaborativeInfo({ collaborativeCode: collaborativeCode ?? 'CG000001' }).then(res => {
            if (res.code == '0') {
                setData(res.data ?? {})
                setOpenFileData(res.data.viewFileList ?? [])
                setDownFileData(res.data.uploadFileList ?? [])
            }
        })
    }

    // 跳转详情
    const viewFile = (item: any) => {
        let fileUrl = activityCode === 'FZCZ' ? `${fzcz_detail}` : item.fileUrl
        // let fileUrl = item.fileUrl
        sessionStorage.setItem('fileUrl', fileUrl)
        sessionStorage.setItem('fileName', item.fileName)
        props.history.push({ pathname: `/collaborativeDetails` });
    }


    // 下载
    const downloadFile = (url: any) => {
        // Utils.downloadFile(url)
    }


    /**
     * 立即报名
     */
    const onSignUp = () => {
        let fromEdcDoctorHome = Utils.getUrlParams().fromEdcDoctorHome || '';
        let param = `?projectCodes=${projectCodes}&tenantCode=${tenantCode}&activityCode=${activiCode}`
        if (fromEdcDoctorHome) {
            param += `&fromEdcDoctorHome=${fromEdcDoctorHome}`;
        }
        if (env === 'development') {
            window.location.href = config.development + param
        }
        else if (env === 'test') {
            window.location.href = config.test + param
        }
        else if (env === 'production') {
            window.location.href = config.production + param
        }
    }

    return (
        <div className={styles.collaborativeNew}>

            {activityCode == 'TYGJ' ? <img src={sign_up_head2} alt='' width={'100%'} style={{ minHeight: '187px' }} /> 
                : activityCode == 'FZCZ' ? <img src={sign_up_head3} alt='' width={'100%'} style={{ minHeight: '187px' }} /> 
                :<img src={sign_up_head} alt='' width={'100%'} style={{ minHeight: '194px' }} />}

            {activityCode == 'TYGJ' ? <img src={sign_up_middle_up2} alt='' width={'100%'} style={{ minHeight: '215px' }} /> 
                : activityCode == 'FZCZ' ? <img src={sign_up_middle_up3} alt='' width={'100%'} style={{ minHeight: '187px' }} /> 
                : <img src={sign_up_middle_up} alt='' width={'100%'} style={{ minHeight: '374px' }} />}

            {activityCode == 'TYGJ' ? <img src={sign_up_middle_down2} alt='' width={'100%'} style={{ minHeight: '340px' }} /> 
                : activityCode == 'FZCZ' ? <img src={sign_up_middle_down3} alt='' width={'100%'} style={{ minHeight: '187px' }} /> 
                : <img src={sign_up_middle_down} alt='' width={'100%'} style={{ minHeight: '360.5px' }} />}

            {/* {
                activityCode != 'TYGJ' && <div className={styles.btn_sign_now}>
                    <Button className={styles.sign_now} type="primary" onClick={onSignUp}>点击立即报名</Button>
                </div>
            }

            {
                activityCode != 'TYGJ' && openFileData.length > 0 && openFileData.map((item: any, index: any) => {
                    return (
                        <div className={styles.btn_file_down} key={index}>
                            <Button className={styles.file_down} type="ghost" onClick={() => { viewFile(item) }}>查看文件</Button>
                        </div>)
                })
            } */}
            <img src={sign_up_bottom} alt='' width={'100%'} style={{ minHeight: '49.5px' }} />
            {
                true &&
                <div className={styles.c_content}>
                    {/* <div className={`${styles.introduce} ${styles.card}`}>
                        <div className={styles.title}><span className={styles.line}></span>{data.collaborativeGroupName || ''}</div>
                        <div className={styles.section}>{data.introduction || ''}</div>
                    </div> */}

                    <div className={`${styles.tabs_content} ${styles.card}`}>
                        <div className={styles.file_title}>
                            <span>公开文件</span>
                        </div>
                        <div>
                            {
                                openFileData.length > 0 && openFileData.map((item: any, index: any) => {
                                    return (<div key={index}>
                                        <div className={styles.list} onClick={() => viewFile(item)}>
                                            <div className={styles.leftCon}>
                                                <img src={iconFile} alt='' width='20%' className={styles.imgCon} />

                                                <div>
                                                    <div className={styles.tit}>{item.fileName}</div>
                                                </div>
                                            </div>
                                            <RightOutline />
                                        </div>
                                    </div>)
                                })
                            }
                        </div>
                        <Tabs>
                            {/* <Tabs.Tab title='公开文件' key='open'>
                                {
                                    openFileData.length > 0 && openFileData.map((item: any, index: any) => {
                                        return (<div key={index}>
                                            <div className={styles.list} onClick={() => viewFile(item)}>
                                                <div className={styles.leftCon}>
                                                    <img src={iconFile} alt='' width='20%' className={styles.imgCon} />

                                                    <div>
                                                        <div className={styles.tit}>{item.fileName}</div>
                                                    </div>
                                                </div>
                                                <RightOutline />
                                            </div>
                                        </div>)
                                    })
                                }
                            </Tabs.Tab> */}
                            {/* <Tabs.Tab title='文件下载' key='down'>
                                {
                                    downFileData.length > 0 && downFileData.map((item: any, index: any) => (
                                        <div className={styles.list} key={index} onClick={() => downloadFile(item.fileUrl)}>
                                            <div className={styles.leftCon}>
                                                <img src={iconFile} alt='' width='20%' className={styles.imgCon} />
                                                <div>
                                                    <div className={styles.tit}>{item.fileName}</div>
                                                </div>
                                            </div>
                                            <RightOutline />
                                        </div>
                                    ))
                                }
                            </Tabs.Tab> */}
                        </Tabs>
                    </div>
                    {/* <Button type="primary" onClick={onSignUp}>点击立即报名</Button> */}

                </div>
            }
        </div>
    )
}

export default Collaborative;